module.exports = __webpack_public_path__ + "img/52_18.7adad9c9.png";